<!--
  A part of a page that can stop without stopping the page. An error thrown
  while what is inside renders or updates (a value worked out from an
  answer of a shape nothing expected) is caught here: that part is replaced
  by a notice saying so, with "Try again", the error goes to the app's log
  (the console, which feedback/logs.ts keeps), and everything outside keeps
  updating. Without it one such error ends every later update of the page,
  so a write that succeeded is never shown.
-->
<script lang="ts">
  import type { Snippet } from 'svelte';

  interface Props {
    /** What is inside, as the notice names it ("the pull request's header"). */
    what: string;
    children: Snippet;
  }
  let { what, children }: Props = $props();

  const words = (e: unknown) => (e instanceof Error ? e.message : String(e));
</script>

<svelte:boundary onerror={(e) => console.error(`Changeling could not show ${what}:`, e)}>
  {@render children()}
  {#snippet failed(error, reset)}
    <div class="banner pane-failed" role="alert" data-pane-failed>
      Changeling could not show {what} ({words(error)}). What you wrote is kept.
      <button class="btn small" onclick={reset}>Try again</button>
    </div>
  {/snippet}
</svelte:boundary>
